// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2RZhl","col":"Table_col__uJxfA","fulfillmentStatus":"Table_fulfillmentStatus__1TPYF","emailCol":"Table_emailCol__2EAr2"};